<template>
  <div class="wrapper">
    <Header class="black"></Header>

    <div class="main">
      <div class="tabbar">
        <ul class="clearfix">
          <li @click="onTabBar(1)" :class="{'on': panelType == 1}">视频案例</li>
          <li @click="onTabBar(2)" :class="{'on': panelType == 2}">制作人</li>
          <li @click="onTabBar(3)" :class="{'on': panelType == 3}">艺人</li>
          <li @click="onTabBar(4)" :class="{'on': panelType == 4}">场地</li>
          <li @click="onTabBar(5)" :class="{'on': panelType == 5}">器材</li>
          <!--<li v-for="item,index in listName" @click="showList(item.key,index)" :class="{'on':i===index}">{{item.name}}</li>-->
        </ul>
      </div>

      <div class="panelbar" v-if="panelType == 3">
        <a :class="{on: panelbar == 1}" @click="onPanelBar(1)">演员</a>
        <a :class="{on: panelbar == 3}" @click="onPanelBar(3)">KOL</a>
        <a :class="{on: panelbar == 4}" @click="onPanelBar(4)">配音</a>
      </div>

      <div class="panels">
        <div class="container">
          <div>
            <div class="empty" v-if="panelType==1&&!caseList.length || panelType==2&&!producerList.length || panelType==3&&!actorList.length || panelType==4&&!venueList.length || panelType==5&&!equipmentList.length">
              <img src="../../assets/images/545.png">
              <div>
                <p class="etitle">空空如也</p>
                <p>您还没有任何收藏哦～</p>
              </div>
            </div>
          </div>
          <div class="panel" v-show="panelType == 1">
            <div class="venue clearfix">
              <div class="item l" v-for="item in caseList" >
                <div class="imgbox">
                  <a :href="'caseDe.html?id='+item.id" target="_blank">
                    <div class="img">
                      <img :src="item.coverUrl"/>
                      <span class="length">{{item.videoLength}}</span>
                    </div>
                    <div class="bg summary">
                      <p>{{item.description}}</p>
                    </div>
                  </a>
                </div>

                <div>
                  <div class="attr">
                    <div class="title">
                      <a :href="'caseDe.html?id='+item.id" target="_blank">{{item.title}}</a>
                      <i class="keep r" @click="cancelCaseKeep(item.id)"></i>
                    </div>
                    <ul class="tag clearfix">
                      <li class="l" v-for="ys,yi in item.typeStr" v-if="yi < 3"><span>{{ys}}</span></li>
                    </ul>
                  </div>

                  <div class="author">
                    <a :href="'userPage.html?id='+item.accountId">
                      <img :src="item.faceUrl">
                      <span class="name">{{item.nickName}}</span>
                      <span class="role">编剧策划/后期制作/灯光道具</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div class="pager" v-show="totalPage/pageSize>1">
              <Page :total="totalPage" :page-size="pageSize" @on-change="onPageChange" :current="currPage"></Page>
            </div>
          </div>

          <div class="panel" v-show="panelType == 2">
            <div class="team">
              <div class="item clearfix" v-for="item in producerList">
                <div class="img l">
                  <a :href="'userPage.html?id='+item.id" target="_blank"><img :src="item.faceUrl" width="100" height="100"/></a>
                </div>

                <div class="info l">
                  <div class="title">
                    <a :href="'userPage.html?id='+item.id"  target="_blank">{{ item.nickName }}</a>
                    <span class="keep r" @click="cancelProducerKeep(item.id)"></span>
                  </div>
                  <div class="summary">{{ item.summary }}</div>
                </div>

                <div class="works l clearfix">
                  <div class="work" v-for="(v,i) in item.sampleList" v-if="i<3">
                    <img :src="v.coverUrl"/>
                    <div class="bg"></div>
                    <a :href="'caseDe.html?id='+v.id" target="_blank">
                      <div class="shade">
                        <i></i>
                      </div>
                    </a>
                    <p>{{v.title}}</p>
                  </div>

                  <div class="work" v-for="rd in item.random">
                    <img :src="mathImg[rd]" style="width: 100%; height: 100%;"/>
                  </div>
                </div>
              </div>
            </div>

            <div class="pager" v-if="totalPage/pageSize>1">
            <Page :total="totalPage" :page-size="pageSize" @on-change="onPageChange" :current="currPage"></Page>
            </div>
          </div>

          <div class="panel" v-show="panelType == 3">
            <div class="container">
              <div class="actor clearfix">
                <div class="item l clearfix" v-for="item in actorList">
                    <div class="img l">
                      <a :href="'talentActor.html?id='+item.id" target="_blank">
                        <img :src="item.coverUrl"/>
                      </a>
                    </div>
                    <div class="info l">
                      <div class="h4">
                        <a :href="'talentActor.html?id='+item.id" target="_blank">{{item.name}}</a>
                        <span class="bgyellow" v-if="panelbar == 1">演员</span>
                        <span class="bgred" v-if="panelbar == 3">KOL</span>
                        <span class="bgblue" v-if="panelbar == 4">配音</span>
                        <i class="keep r" @click="cancelActorKeep(item.id)"></i>
                      </div>
                      <div class="tag" v-if="panelbar == 1">
                        <span>类型：{{getModelType(item.type)}}</span>
                        <span>身高：{{item.height}}cm</span>
                        <span>体重：{{item.weight}}kg</span>
                      </div>
                      <div class="summary">{{item.summary}}</div>
                    </div>
                  <!--</a>-->
                </div>
              </div>

              <div class="pager" v-if="totalPage/pageSize>1">
                <Page :total="totalPage" :page-size="pageSize" @on-change="onPageChange" :current="currPage"></Page>
              </div>
            </div>
          </div>

          <div class="panel" v-show="panelType == 4">
            <div class="container">
              <div class="venue clearfix">
                <div class="item l" v-for="item in venueList" >
                  <div class="imgbox">
                    <a :href="'venueDetails.html?id='+item.id+'&type=1'">
                      <img :src="item.cover"/>
                    </a>
                  </div>

                  <div>
                    <div class="attr">
                      <div class="title">
                        <a :href="'venueDetails.html?id='+item.id+'&type=1'">{{item.name}}</a>
                        <i class="keep r" @click="cancelVenueKeep(item.id)"></i>
                      </div>
                      <div class="tag">
                        <span>{{item.location | venueLocal}}</span>
                        <span>{{item.area}}m&sup2;</span>
                        <span>{{item.typeStr}}</span>
                        <span>{{item.purposeStr}}</span>
                      </div>
                    </div>

                    <div class="author">
                      <a :href="'userPage.html?id='+item.accountId">
                        <img :src="item.faceUrl">
                        <span class="name">{{item.nickName}}</span>
                        <span class="role">编剧策划/后期制作/灯光道具</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="pager"  v-if="totalPage/pageSize>1">
                <Page :total="totalPage" :page-size="pageSize" @on-change="onPageChange" :current="currPage"></Page>
              </div>
            </div>
          </div>

          <div class="panel" v-show="panelType == 5">
            <div class="container">
              <div class="venue clearfix">
                <div class="item l" v-for="item in equipmentList" >
                  <div class="imgbox">
                    <a :href="'venueDetails.html?id='+item.id+'&type=2'">
                      <img :src="item.cover"/>
                    </a>
                  </div>

                  <div class="info">
                    <div class="attr">
                      <div class="title">
                        <a :href="'venueDetails.html?id='+item.id+'&type=2'">{{item.name}}</a>
                        <i class="keep r" @click="cancelEquipmentKeep(item.id)"></i>
                      </div>
                    </div>

                    <div class="author">
                      <a :href="'userPage.html?id='+item.accountId">
                        <img :src="item.faceUrl">
                        <span class="name">{{item.nickName}}</span>
                        <span class="role">编剧策划/后期制作/灯光道具</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="pager" v-if="totalPage/pageSize>1">
                <Page :total="totalPage" :page-size="pageSize" @on-change="onPageChange" :current="currPage"></Page>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>
<script>
import "@/assets/js/common";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { caseIndex, userPageApi, EquipmentApi, VenueApi } from "../../fetch/api";
import dict from "@/util/dict";

export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {
      pageSize: 12, //每页条数
      totalPage: 0,  //总页数
      currPage: 1, //当前页数
      mathImg: dict.mathImg,
      panelType: 1,
      actorList: [],
      caseList: [],
      producerList: [],
      venueList: [],
      equipmentList: [],
      panelbar: 1,
      empty: false
    };
  },
  mounted() {
    this.getCaseKeepList();
  },
  methods: {
    onPanelBar(val){
      this.panelbar = val;
      this.getActorKeepList();
    },
    onTabBar(val) {
      this.totalPage = 0;
      this.currPage = 1;
      this.panelType = val;
      if (val == 1) {
        this.pageSize = 12;
        this.getCaseKeepList();
      } else if (val == 2) {
        this.pageSize = 8;
        this.getProducerKeepList();
      } else if (val == 3) {
        this.pageSize = 8;
        this.getActorKeepList();
      } else if (val == 4) {
        this.pageSize = 9;
        this.getVenueKeepList();
      } else {
        this.pageSize = 9;
        this.getEquipmentKeepList();
      }
    },
    onPageChange(no){
      this.currPage = no;
      if(this.panelType == 1){
        this.getCaseKeepList();
      } else if(this.panelType == 2){
        this.getProducerKeepList();
      } else if(this.panelType == 3){
        this.getActorKeepList();
      } else if(this.panelType == 4){
        this.getVenueKeepList();
      } else {
        this.getEquipmentKeepList();
      }
    },
    cancelCaseKeep(id){
      let params = {
        "type": 2,
        "sampleId": id
      }
      caseIndex.apiAccountWorkSampleKeep(params).then(data => {
        if(data.status == 1){
          msgSuccess("取消成功");
          this.getCaseKeepList();
        }
      });
    },
    cancelProducerKeep(id) {
      let params = {
        "type": 2,
        "producerId": id
      }
      userPageApi.apiAccountProducerKeep(params).then(data => {
          if(data.status == 1){
            msgSuccess("取消成功");
            this.getProducerKeepList();
          }
        });
    },
    cancelActorKeep(id) {
      let params = {
        "type": 2,
        "modelId": id
      }
      caseIndex.modelKeep(params).then(data => {
        if(data.status == 1){
          msgSuccess("取消成功");
          this.getActorKeepList();
        }
      });
    },
    cancelVenueKeep(id) {
      let params = {
        "type": 2,
        "venueId": id
      }
      VenueApi.venueKeep(params).then(data => {
        if(data.status == 1){
          msgSuccess("取消成功");
          this.getVenueKeepList();
        }
      });
    },
    cancelEquipmentKeep(id) {
      let params = {
        "type": 2,
        "equipmentId": id
      }
      EquipmentApi.equipmentKeep(params).then(data => {
        if(data.status == 1){
          msgSuccess("取消成功");
          this.getEquipmentKeepList();
        }
      });
    },
    getCaseKeepList(){
      let params = {
        "pageNo": this.currPage,
        "pageSize": this.pageSize
      }
      caseIndex.workSampleKeepList(params).then(data => {
        for (let item of data.list) {
          item.typeStr = item.typeStr.split(",");
        }
        this.totalPage = data.counts;
        this.caseList = data.list;
      });
    },
    getActorKeepList(){
      let params = {
        "pageNo": this.currPage,
        "pageSize": this.pageSize,
        "type": this.panelbar
      }
      caseIndex.modelKeepList(params).then(data => {
        this.totalPage = data.counts;
        this.actorList = data.list;
      });
    },
    getProducerKeepList(){
      let params = {
        "pageNo": this.currPage,
        "pageSize": this.pageSize
      }
      caseIndex.producerKeepList(params).then(data => {
        data.list.forEach(item => {
          var num = 3 - item.sampleList.length;
          let random = [];
          for (let i = 0; i < num; i++) {
            random.push(Math.round(Math.random() * 48));
          }
          item.random = random;
        });

        this.totalPage = data.counts;
        this.producerList = data.list;
      });
    },
    getVenueKeepList(){
      let params = {
        "pageNo": this.currPage,
        "pageSize": this.pageSize
      }
      VenueApi.venueKeepList(params).then(data => {
        this.totalPage = data.counts;
        this.venueList = data.list;
      });
    },
    getEquipmentKeepList(){
      let params = {
        "pageNo": this.currPage,
        "pageSize": this.pageSize
      }
      EquipmentApi.equipmentKeepList(params).then(data => {
        this.totalPage = data.counts;
        this.equipmentList = data.list;
      });
    },
    getModelType(i) {
      return dict.artist[i - 1];
    }
  }
};
</script>
<style scoped>
.wrapper{
  background: #f5f5f5;
}
.main{
  min-height:600px;
  width:1200px;
  margin:0 auto;
}
.keep{
  display: inline-block;
  margin-top: 5px;
  width: 15px;
  height: 15px;
  background: url("../../assets/images/icon_collec2.png") no-repeat scroll center;
}
.panelbar{
  padding-top: 20px;
}
.panelbar a{
  margin-right: 50px;
  font-size: 16px;
}
.panelbar a.on{
  color: #3E87FF;
}
.tabbar{
  margin-top: 20px;
  background: #ffffff;
}
.tabbar li{
  float: left;
  margin: 0 40px;
  padding: 15px 0;
  font-size: 18px;
  cursor: pointer;
  border-bottom: 2px solid #ffffff;
}
.tabbar li.on {
  font-weight: 600;
  border-bottom: 2px solid #3e87ff;
}
.panels{
  margin-top: 20px;
  padding-bottom: 100px;
  min-height: 800px;
}
.venue .item{
  margin: 0 0 30px 30px;
  width: 380px;
  background: #FFFFFF;
  cursor: pointer;
}
.venue .item:nth-child(3n+1){
  margin-left: 0px;
}
.venue .item .imgbox{
  position: relative;
  /*height: 214px;*/
  height: 304px;
  overflow: hidden;
}
.panel:nth-child(1) .venue .item .imgbox{
  height: 214px;
}
.venue .item .imgbox img{
  width: 100%;
  height: 304px;
  object-fit: cover;
}
.panel:nth-child(1) .venue .item .imgbox img{
  height: 304px;
}
.venue .item .imgbox .length{
  position: absolute;
  right: 15px;
  bottom: 10px;
  color: #ffffff;
  z-index: 100;
}
.venue .imgbox .bg{
  position: absolute;
  top: 0;
  padding: 15px;
  width: 100%;
  height: 100%;
  color: #ffffff;
  font-size: 12px;
  background: rgba(13,20,37,.6);
  border-radius: 2px;
  opacity: 0;
  transition: all .5s;
}
.venue .item .attr{
  padding: 15px;
  border-bottom: 1px solid #EFEFEF;
}
.venue .item .title a{
  display: inline-block;
  max-width: 330px;
  font-size: 18px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.venue .item .tag{
  margin-top: 6px;
  font-size: 12px;
  opacity: 0.7;
}
.venue ul.tag span{
  margin-right: 5px;
  display: inline-block;
  padding: 3px 10px;
  background: #F0F0F0;
  border-radius: 2px;
}
.venue .item .tag span{
  margin-right: 10px;
}
.venue .item .author{
  padding: 15px;
}
.venue .item .author img{
  margin-right: 10px;
  width: 25px;
  height: 25px;
  border-radius: 50%;
}
.venue .item .author .name{
  display: inline-block;
  margin-right: 15px;
  max-width: 120px;
  font-size: 12px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
}
.venue .item .author .role{
  font-size: 12px;
  opacity: 0.6;
}
.venue .item:hover .title a{
  color: #3E87FF;
}
.venue .item:hover .imgbox .bg{
  opacity: 1;
}

.team .item{
  margin-bottom: 20px;
  padding: 18px 12px;
  border-bottom: 1px solid #F2F2F2;
  background: #ffffff;
}
.team .item:hover{
  background: #F8FAFC;
}
.team .item:hover .info .title a{
  color: #3D85FB;
}
.team .item .img img{
  margin-top: 18px;
  width: 100px;
  height: 100px;
  border-radius: 50%;
}
.team .item .info{
  padding: 0 65px 0 20px;
  width: 280px;
}
.team .item .info .title{
  margin: 22px 0 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.team .item .info .title a{
  color: #424753;
  font-size: 16px;
  font-weight: 600;
}
.team .item .info .summary{
  color: #9B9B9B;
  max-height: 60px;
  overflow: hidden;
}
.team .works .work{
  position: relative;
  float: left;
  margin-left: 20px;
  width: 240px;
  height: 135px;
  cursor: pointer;
  overflow: hidden;
}
.team .works .work:first-child{
  margin-left: 0;
}
.team .works .work .bg{
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(0deg, rgba(0,0,0,.9),rgba(0,0,0,0));
}
.team .works .work p{
  position: absolute;
  bottom: 15px;
  padding: 0 10px;
  color: #ffffff;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.team .works .work .shade{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  background: rgba(0,0,0,0.40);
  transition: all .5s;
}
.team .works .work:hover .shade{
  opacity: 1;
}
.team .works .work .shade i{
  display: block;
  margin: 44px auto 0;
  width: 40px;
  height: 40px;
  background: url("../../assets/images/play.png") no-repeat scroll center;
}

.actor .item{
  margin: 0 20px 20px 0;
  width: 590px;
  background: #FFFFFF;
}
.actor .item:nth-child(2n){
  margin-right: 0;
}
.actor .item .img{
  width: 160px;
  height: 160px;
  overflow: hidden;
}
.actor .item .info{
  padding: 20px;
  width: 430px;
  height: 160px;
  color: #9B9B9B;
}
.actor .item .info .h4 a{
  margin-right: 10px;
  color: #424753;
  font-weight: 600;
  vertical-align: middle;
}
.actor .item .info .h4 span{
  display: inline-block;
  padding: 0 4px;
  font-size: 11px;
  color: #FFFFFF;
  border-radius: 2px;
}
.actor .item .info .tag{
  margin: 10px 0;
}
.actor .item .info .tag span{
  display: inline-block;
  margin-right: 30px;
  width: 90px;
}
.actor .item .info .summary{
  height: 40px;
  line-height: 20px;
  overflow: hidden;
}

.pager{
  padding: 40px;
  text-align: center;
}





.con-list {
  width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
  overflow: hidden;
}
.con-li {
  margin: 0 10px;
  width: 380px;
  background: #fff;
  float: left;
  margin-bottom: 30px;
  cursor: pointer;
  position: relative;
}
.con-li-hover {
  height: 0;
  width: 100%;
  opacity: 0;
  transition: 0.5s all;
  position: absolute;
  top: 0;
  left: 0;
  padding: 20px;
  color: #fff;
  z-index: 9;
}
.con-li:hover .con-li-hover {
  opacity: 1;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.2);
  height: 214px;
}
.con-li h2 {
  font-family: PingFangSC-Medium;
  font-size: 18px;
  color: #424753;
  letter-spacing: 0;
  padding: 15px 0 8px 0;
}
.con-img {
  width: 380px;
  height: 214px;
  position: relative;
}
.con-img-hover {
  width: 380px;
  height: 214px;
  position: absolute;
  top: 0;
  left: 0;
  display: none;
}
.con-img img {
  width: 100%;
  height: 100%;
}
.con-type-list {
  height: 20px;
  padding-bottom: 40px;
  font-family: PingFangSC-Regular;
}
.con-type-list li {
  float: left;
  padding: 3px 10px;
  background: #f0f0f0;
  margin-right: 5px;
}
.user {
  width: 100%;
  text-align: left;
  padding: 15px 0;
  line-height: 25px;
  border-top: 1px solid #efefef;
  color: #5e6370;
  font-size: 12px;
}
.user img {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  margin-right: 15px;
  display: inline-block;
  vertical-alian: middle;
}
.user,
.con-type-list,
.con-li h2 {
  padding-left: 15px;
  /*height: 50px;*/
  width: calc(100% - 40px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.page {
  text-align: center;
  padding: 20px 0 70px 0;
}
.con-type-list li {
  font-size: 12px;
  color: #5e6370;
}

.list {
  padding-bottom: 40px;
}
.list .item {
  border-bottom: 1px solid #f2f2f2;
  background: #ffffff;
}
.list .item:last-child {
  border-bottom: 0;
}
.list .item > div {
  padding: 18px 30px;
}
.list .item > div > div {
  float: left;
}
.list .item .img {
  text-align: center;
}

.list .item .img img {
  margin: 22px auto 0;
  width: 100px;
  height: 100px;
  border-radius: 50%;
}
.md .list .item .img img {
  /* margin: 22px auto 0; */
  width: 100%;
  /* height: 100%; */
  /* border-radius: 50%; */
  margin: 0;
  height: auto;
  border-radius: 0;
}
.list .item .info {
  padding-left: 20px;
  width: 279px;
}
.list .item .info .h4 {
  /* margin-top: 46px; */
}
.list .item .info .h4 a {
  color: #424753;
  font-weight: 600;
}
.list .item .info .job {
  margin-top: 10px;
  padding-right: 20px;
  color: #9b9b9b;
  height: 67px;
  overflow: hidden;
}
.list .item .works-list .works-item {
  position: relative;
  float: left;
  margin-left: 20px;
  width: 240px;
  height: 135px;
  cursor: pointer;
  overflow: hidden;
}
.list .item .works-list .works-item:first-child {
  margin-left: 0;
}
.list .item .works-list .works-item .bg {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0));
}
.list .item .works-list .works-item p {
  position: absolute;
  bottom: 15px;
  padding: 0 10px;
  color: #ffffff;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.list .item .works-list .works-item .shade {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  background: rgba(0, 0, 0, 0.4);
  transition: all 0.5s;
}
.list .item .works-list .works-item:hover .shade {
  opacity: 1;
}
.list .item .works-list .works-item .shade i {
  display: block;
  margin: 44px auto 0;
  width: 40px;
  height: 40px;
  background: transparent url("../../assets/images/play.png") no-repeat scroll
    center;
}

.model .list .item {
  float: left;
  margin-top: 20px;
  margin-left: 20px;
  width: 590px;
  background: #ffffff;
}
.model .list .item:nth-child(-n-2) {
  margin-top: 0;
}
.model .list .item:nth-child(2n + 1) {
  margin-left: 0;
}
.model .list .item a > div {
  float: left;
}
.model .list .item .img {
  width: 160px;
  height: 160px;
  overflow: hidden;
}
.model .list .item .info {
  padding: 20px 20px 18px 20px;
  width: 430px;
  height: 160px;
  color: #9b9b9b;
}
.model .list .item .info .h4 {
  margin-bottom: 10px;
}
.model .list .item .info .h4 a {
  margin-right: 10px;
  color: #424753;
  font-weight: 600;
  vertical-align: middle;
}
.model .list .item .info .h4 span {
  display: inline-block;
  padding: 0 4px;
  line-height: 18px;
  text-align: center;
  font-size: 11px;
  color: #3e87ff;
  background: rgba(62, 135, 255, 0.2);
  border-radius: 2px;
}
.model .list .item .info .h4 span.w {
  color: #ff5555;
  background: rgba(255, 85, 85, 0.2);
  border-radius: 2px;
}
.model .list .item .info .tag {
  margin-bottom: 10px;
}
.model .list .item .info .tag span {
  display: inline-block;
  margin-right: 30px;
  width: 90px;
  font-size: 14px;
  color: #424753;
}
.model .list .item .info .summary {
  height: 40px;
  overflow: hidden;
  line-height: 20px;
}
.model .list .item .info .summary.a {
  height: 60px;
}
.fx {
  width: 15px;
  position: absolute;
  right: 20px;
  bottom: 112px;
  cursor: pointer;
}
.fx2 {
  width: 15px;
  position: absolute;
  right: 25px;
  top: 29px;
  cursor: pointer;
}
.fx3 {
  width: 15px;
  position: absolute;
  right: 38px;
  top: 28px;
  cursor: pointer;
}
.bgyellow{
  background: #FBAC00;
}
.bgblue{
  background: #61A9FF;
}
.bgred{
  background: #F94C48;
}
.empty{
  padding: 80px 0;
  text-align: center;
  background: #ffffff;
}
.empty .etitle{
  margin: 20px 0 10px;
  font-size: 20px;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// collectionList.vue?19b6fa26